export function isServicePendingClassification(service) {
  return !service?.service_family_id;
}

export function formatServiceClassificationLabel(service) {
  const family = service?.family;
  if (!family) return null;

  const sub = family.subcategory;
  const cat = sub?.category;

  if (cat?.code && sub?.code && family?.code) {
    const names = [cat.name, sub.name, family.name].filter(Boolean).join(' › ');
    return names || `${cat.code} — ${sub.code} — ${family.code}`;
  }

  return family.name || family.code || null;
}
